module.exports = __webpack_public_path__ + "static/img/11.540bfe4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/11.png
// module id = rE6K
// module chunks = 0